<script setup lang="ts">
import type { PropType } from 'vue'
import { ref } from 'vue'
import LoaderSmall from '@/components/Elements/Loaders/LoaderSmall.vue'

const props = defineProps({
  active: {
    type: Boolean,
    default: false
  },
  fullWidth: {
    type: Boolean,
    default: false
  },
  forIcon: {
    type: Boolean,
    default: false
  },
  spinner: {
    type: Boolean,
    default: false
  },
  type: {
    type: String as PropType<'button' | 'submit' | 'reset'>,
    default: 'button'
  },
  color: {
    type: String as PropType<'default' | 'darker' | 'red' | 'green' | 'blue' | 'gray'>,
    default: 'default'
  }
})

/**
 * Variables
 */
const spinning = ref(false)

/**
 * Functions
 */
const clicked = () => {
  if (props.spinner) {
    spinning.value = true
  }
}
</script>

<template>
  <button
    :type="type"
    @click="clicked"
    :class="{
      'py-1 rounded text-slate-300': true,
      'hover:bg-slate-500': color === 'default' || color === 'darker' || color === 'gray',
      'hover:bg-slate-700': color === 'red' || color === 'green' || color === 'blue',
      'bg-slate-700': active && color === 'default',
      'bg-slate-600': !active && (color === 'default' || color === 'darker'),
      'bg-red-500': color === 'red',
      'bg-green-500': color === 'green',
      'bg-blue-500': color === 'blue',
      'bg-gray-500': color === 'gray',
      'text-white': color === 'red' || color === 'green' || color === 'blue' || color === 'gray',
      'w-full': fullWidth,
      'px-2': !forIcon,
      'px-1': forIcon,
      'cursor-none': spinning
    }"
  >
    <span v-if="spinner && spinning">
      <LoaderSmall />
    </span>
    <span v-if="!spinner || !spinning">
      <slot></slot>
    </span>
  </button>
</template>

<style scoped lang="scss"></style>
